import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
const TopFooter = (props) => {
  const { t } = useTranslation();
  return (
    <div>
      <footer class="main-footer">
        
          {t('footer.copyrightPrefix', { year: moment().format('YYYY') })} <a href="#">iPoultry</a>. {t('footer.rightsReserved')}
      </footer>
    </div>
  );
};
export default TopFooter;
